import "./init-sentry";
import * as Sentry from "@sentry/react";
import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router-dom";
// import { PostHogProvider } from "posthog-js/react";
import { appRouter } from "@/app/appRouter";
import ReactDOM from "react-dom/client";
import { Theme } from "@radix-ui/themes";
import { Provider } from "react-redux";
import { appStore } from "@/app/appStore";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import isBetween from "dayjs/plugin/isBetween";
import "vis-timeline/styles/vis-timeline-graph2d.css";
import "@/shared/base.css";
import "@radix-ui/themes/styles.css";
import "react-day-picker/style.css";

dayjs.extend(duration);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(isBetween);

// PostHog disabled to stop product analytics usage — re-enable by
// restoring PostHogProvider below and the import above.
// const options = {
//   api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
// };

async function enableMocking() {
  if (import.meta.env.VITE_MOCK_SERVER !== "true") {
    return;
  }

  const { worker } = await import("../mocks/browser");

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start();
}

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <Provider store={appStore}>
        <Theme radius="large">
          <RouterProvider
            router={appRouter()}
            future={{
              v7_startTransition: false,
            }}
          />
        </Theme>
        <Toaster />
      </Provider>
    </Sentry.ErrorBoundary>
  );
});
